import { Grid } from '../Grid';
import { GradientHeader } from '../GradientHeader';
import React from 'react';

export const PageHeader = ({ children }: React.PropsWithChildren) => {
  return (
    <GradientHeader>
      <Grid gap="Space10" maxWidth="50em" paddingX="Space10">
        {children}
      </Grid>
    </GradientHeader>
  );
};
